import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { StoreApp } from './StoreApp'
import './store.css'

const container = document.getElementById('root')
if (!container) throw new Error('Missing #root element')

createRoot(container).render(
  <StrictMode>
    <StoreApp />
  </StrictMode>,
)
